import React, { PureComponent } from "react";
import { Platform, StatusBar, Text, TouchableOpacity, View } from "react-native";
import { Button } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
import Modal from "react-native-modal";
import { withTranslation } from "react-i18next";
import { blendColor } from "../../utils/BlendColor";
import * as Helper from "../../utils/Helper";
// import { launchCamera, launchImageLibrary } from "react-native-image-picker";
// import { PERMISSIONS, requestMultiple, RESULTS } from "react-native-permissions";
import UIDs from "../../UIDs";

import Dimensions from "react-native-web-dimension-helper";

const uid = UIDs.components.ui.imagePickerModal;

class ImagePickerModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    showImagePicker(options, cb) {
        if (this._pendingPick !== undefined) {
            return;
        }

        this._options = options;
        this._pendingPick = cb;
        this.setState({ visible: true });
    }

    // async takePhoto() {
    //     if (Platform.OS === "ios") {
    //         var perms = await requestMultiple([PERMISSIONS.IOS.CAMERA, PERMISSIONS.IOS.STOREKIT]);
    //     } else {
    //         var perms = await requestMultiple([PERMISSIONS.ANDROID.CAMERA, PERMISSIONS.ANDROID.READ_EXTERNAL_STORAGE, PERMISSIONS.ANDROID.WRITE_EXTERNAL_STORAGE]);
    //     }
    //
    //     for (let i = 0; i < perms.length; ++i) {
    //         if (perms[i] !== RESULTS.GRANTED) {
    //             this.setState({ error: this.props.t("noPermission") });
    //             return;
    //         }
    //     }
    //
    //     const options = this._options || {
    //         //quality: 1.0,
    //         //maxWidth: 500,
    //         //maxHeight: 500,
    //         noData: true,
    //         storageOptions: {
    //             skipBackup: true,
    //             waitUntilSaved: true,
    //         },
    //     };
    //
    //     launchCamera(options, response => {
    //         if (!this._pendingPick) {
    //             return;
    //         }
    //
    //         this.setState({ visible: false });
    //         if (response.didCancel) {
    //             this._pendingPick(response);
    //             delete this._pendingPick;
    //             console.log("User cancelled photo picker");
    //         } else if (response.errorMessage) {
    //             this._pendingPick(response);
    //             delete this._pendingPick;
    //         } else {
    //             response = response.assets ? response.assets[0] : {};
    //             this._pendingPick(response);
    //             delete this._pendingPick;
    //         }
    //     });
    // }

    pickPhoto() {
        if (this.fileInput) {
            this.fileInput.click();
        }
    }

    handleFileChange(event, key) {
        const fileObject = event.target.files[0];
        if (!fileObject) {
            return;
        }
        const response = fileObject;
        this._pendingPick(response);
    }

    _handleClose = () => {
        if (this._pendingPick) {
            this._pendingPick({ didCancel: true });
        }
        delete this._pendingPick;
        delete this._options;
        this.setState({ visible: false });
    };

    renderPick() {
        const screenWidth = Helper.getContainerSize().width;
        return (
            <View style={{ width: screenWidth * 0.9, paddingLeft: 20, paddingRight: 20, paddingTop: 4, paddingBottom: 20, flexDirection: "column", borderRadius: 10, backgroundColor: "#fff" }}>
                <View style={{ zIndex: 1, flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }} />
                    <TouchableOpacity
                        onPress={() => {
                            this._handleClose();
                        }}>
                        <Icon name="ios-close" style={{ fontSize: 46, color: "#999999", marginRight: 0 }} />
                    </TouchableOpacity>
                </View>
                <View style={{ flexDirection: "column", alignItems: "center", marginTop: -30 }}>
                    <Text style={{ fontSize: 18, fontWeight: "bold" }}>{this.props.t("pickImage")}</Text>
                </View>
                <View style={{ flexDirection: "column", alignItems: "center", marginTop: 20 }}>
                    <input ref={fileInput => (this.fileInput = fileInput)} type="file" style={{ display: "none" }} onChange={e => this.handleFileChange(e, this._pendingKey)} />
                    {/*<Button
                        style={{ width: "80%", height: 40, backgroundColor: "#1E90FF", borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                        transparent
                        onPress={() => {
                            this.takePhoto();
                        }}>
                        <Text style={{ color: "#fff" }}>{this.props.t("takePhoto")}</Text>
                    </Button>*/}
                    <Button
                        style={{ width: "80%", height: 40, backgroundColor: "#1E90FF", marginTop: 8, borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                        transparent
                        onPress={() => {
                            this.pickPhoto();
                        }}>
                        <Text style={{ color: "#fff" }}>{this.props.t("pickPhoto")}</Text>
                    </Button>
                    <Button
                        style={{ width: "80%", height: 40, backgroundColor: "#1E90FF", marginTop: 8, borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                        transparent
                        onPress={() => {
                            this._handleClose();
                        }}>
                        <Text style={{ color: "#fff" }}>{this.props.t("cancel")}</Text>
                    </Button>
                </View>
            </View>
        );
    }

    render() {
        return (
            <Modal
                isVisible={this.state.visible}
                backdropOpacity={0.4}
                /*animationIn='none' animationOut='none'
                       animationInTiming={0} animationOutTiming={0}
                       backdropTransitionInTiming={0} backdropTransitionOutTiming={0}*/
                avoidKeyboard={true}
                style={{ alignItems: "center", justifyContent: "center", zIndex: 100 }}
                onBackButtonPress={() => this._handleClose()}
                onBackdropPress={() => this._handleClose()}>
                {this.props.barColor ? <StatusBar barStyle={this.props.barStyle} backgroundColor={blendColor(this.props.barColor, "rgba(0,0,0,0.4)")} /> : null}
                {this.renderPick()}
            </Modal>
        );
    }
}

export default withTranslation(uid, { withRef: true })(ImagePickerModal);
